import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";

import { makeBriefDeliverableQueryKey } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { IBriefDeliverableResponse } from "@shared/lib/types/briefInfluencerV2";

export function useGetBriefDeliverable(deliverableId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IBriefDeliverableResponse>
  >({
    queryKey: makeBriefDeliverableQueryKey(deliverableId),
    queryFn: () => BriefService.getBriefDeliverable(deliverableId),
    enabled: !!deliverableId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    deliverable: data?.data,
    isFetching: isLoading,
    isError,
  };
}
